var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicesZeroStateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2727,
    cy: 16.6279,
    rx: 15.2727,
    ry: 15.6279,
    fill: "#EAF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0918 12.0234V18.4234C25.0918 18.8478 25.2393 19.2547 25.5018 19.5548C25.7644 19.8549 26.1205 20.0234 26.4918 20.0234H32.0918",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0918 12.0234V18.4234C25.0918 18.8478 25.2393 19.2547 25.5018 19.5548C25.7644 19.8549 26.1205 20.0234 26.4918 20.0234H32.0918",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5327 40.0697H14.5055C13.7084 40.0697 12.9439 39.7381 12.3803 39.1479C11.8166 38.5577 11.5 37.7571 11.5 36.9224V14.8914C11.5 14.0567 11.8166 13.2562 12.3803 12.666C12.9439 12.0757 13.7084 11.7441 14.5055 11.7441H25.0245L32.5382 19.6124V36.9224C32.5382 37.7571 32.2215 38.5577 31.6579 39.1479C31.0943 39.7381 30.3298 40.0697 29.5327 40.0697Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0371 34.209H19.2517",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0371 26.4736H25.8953",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0371 30.3027H25.8953",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7053 16.2374C16.9145 16.2374 16.2734 16.7622 16.2734 17.4095C16.2734 18.0568 16.7507 18.5816 17.7053 18.5816C18.6598 18.5816 19.1371 19.1064 19.1371 19.7537C19.1371 20.401 18.496 20.9258 17.7053 20.9258M17.7053 16.2374C18.2352 16.2374 18.6979 16.4731 18.9455 16.8235M17.7053 16.2374V15.6514M17.7053 20.9258L17.7053 21.5118M17.7053 20.9258C17.1753 20.9258 16.7126 20.6901 16.465 20.3397",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesZeroStateIcon);
export default __webpack_public_path__ + "static/media/invoices-zero-state-icon.a69b42bd69224e17160ca5c3e405e80a.svg";
export { ForwardRef as ReactComponent };